import React, { useEffect, useState, Dispatch } from "react"
import { DataType } from "../interface/interface"
import { getOlpnList } from "../../api/OLPN/olpn"
import { useNavigate } from 'react-router-dom'
import { Modal, Space, Button, Spin, Table } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import moment from "moment"
import "./selectOlpn.css"
import { createOLPN, setCurrentOLPN } from "../../api/OLPN/olpn";


interface IList { OLPN: string, _id: string, modifiedAt: string, createdAt: string }

const SelectOLPN = (props: { bp: DataType | undefined, setOpen: Dispatch<boolean>, isOpen: boolean }) => {
  const { bp, setOpen, isOpen } = props
  const [list, setList] = useState<IList[] | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)
  const [current, setCurrent] = useState<IList | undefined>(undefined)
  const navigate = useNavigate()

  useEffect(() => {
    getOLPNList()
  }, [isOpen])


  const columns = [
    {
      title: 'Informations',
      dataIndex: 'modifiedAt',
      key: 'modifiedAt',
      render: (elem: string) => renderDate("", elem)
    },
    {
      title: 'Action',
      dataIndex: '_id',
      key: 'action',
      render: (elem) => <Button id="continue" onClick={() => handleContinue(elem)}>Continuer</Button>
    },
  ];

  const getOLPNList = async () => {
    if (!bp) return

    setLoading(true)
    const bpId = bp.bpNumber
    const res = await getOlpnList(bpId)
    if (res.status === 200) {
      setList(res.data)
      if (res.data.length > 0) {
        res.data.forEach((elem: IList) => {
          if (elem.OLPN === "") setCurrent(elem)
        })
      }
    } else {
      setList(undefined)
    }
    setLoading(false)
  }

  const renderDate = (createdAt: string, modifiedAt: string) => {
    var modified = moment(new Date(modifiedAt)).format('Do MMMM YYYY HH:mm:ss')
    return "Colis en cours, dernier scan le " + modified
  }

  const handleContinue = async (selected) => {
    if (selected && selected !== 'new')
      await setCurrentOLPN(Number(bp?.bpNumber), selected)
    else if (selected && selected === 'new')
      await createOLPN(Number(bp?.bpNumber))
    if (bp?.bpNumber && bp.sku)
      navigate("/scanning/" + bp.bpNumber + "/" + bp.sku, { state: bp })
  }

  return (
    <Modal
      // style={{ height: '100vh', margin: 0, top: 0, width: "100vw" }}
      // bodyStyle={{ height: "calc(100vh - 110px)", overflow: 'auto' }}
      bodyStyle={{ overflow: 'auto' }}
      width={1000}
      open={isOpen}
      onCancel={() => setOpen(false)}
      closable={false}
      footer={[
        <Button onClick={() => setOpen(false)} className="footer-button cancel">Annuler</Button>]}
    >
      <div className="olpn-modal-title" >
        <span className="olpn-modal-title">
          Il y a {list && list.length > 0 ? list.length : 'aucun'} colis en cours.
        </span>
      </div>
      <div >
        <Spin spinning={loading} indicator={<LoadingOutlined />}>
          <Space direction="vertical" style={{ width: '100%', textAlign: "-webkit-center" }}>
            {
              list && list.length > 0 &&
              <Table bordered style={{ width: '75%' }} dataSource={list} columns={columns} pagination={{ position: [] }} />
            }
          </Space>
        </Spin>
      </div>
      <div className="new-olpn-div">
        <Button onClick={() => handleContinue('new')} className="new-button">Nouveau colis</Button>
      </div>
    </Modal>
  )
}

export default SelectOLPN